import Logger from '../../../../common/logger';
import Scripts from '../../../../common/scripts';

const Definitions = {
    load: (dirUrl, qName, onSuccess, onError) => {
        if (!dirUrl || !qName) {
            Logger.warn('Definitions: incorrect definition parameters');
            onError();
            return;
        }
        Scripts.loadJSON({
            url: `${dirUrl}q-${qName}.json`,
            successCallback: (result) => {
                onSuccess(result);
            },
            errorCallback: (error) => {
                Logger.error(`Definitions: error loading definitions ${error.message}`);
                onError();
            }
        });
    },
    loadWithArray: (dir, qName, onSuccess, onError) => {
        if (!dir || !qName) {
            Logger.warn('Definitions: incorrect definition parameters');
            onError();
            return;
        }
        onSuccess(dir[qName]);
    },
    postProcess: (config) => {
        if (!config.questionnaireStructure) {
            return config;
        }

        const qStructure = config.questionnaireStructure;

        //--Sorting
        try {
            qStructure.sort((a, b) => parseInt(a.questionOrder) - parseInt(b.questionOrder));
        } catch (error) {
            Logger.error(`Definitions: error sorting questions ${config.questionnaireName}`);
        }

        //--Complement missing parameters
        if (!config.questionnaireType) {
            qStructure.forEach((q) => {
                if (q.answerType === 'radio') {
                    q.answerRequired = true;
                } else {
                    q.answerRequired = false;
                }
            });
        }

        config.questionnaireStructure = qStructure;

        return config;
    }
};

export default Definitions;
